import { render, staticRenderFns } from "./Refer.vue?vue&type=template&id=164430d3&"
import script from "./Refer.vue?vue&type=script&lang=js&"
export * from "./Refer.vue?vue&type=script&lang=js&"
import style0 from "./Refer.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports